import { useTranslation } from 'react-i18next';
import { SUPPORT_EMAIL } from 'utils/supportEmail';
import {
  SupportHintBox,
  SupportHintLink,
  SupportHintText,
  SupportHintTitle,
} from './SupportHint.styles';

export const SupportHint = () => {
  const { t } = useTranslation();
  return (
    <SupportHintBox>
      <SupportHintTitle>{t('audio.troubleshooting.help.title')}</SupportHintTitle>
      <SupportHintText>
        {t('audio.troubleshooting.help.prefix')}{' '}
        <SupportHintLink href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</SupportHintLink>
        {t('audio.troubleshooting.help.suffix')}
      </SupportHintText>
    </SupportHintBox>
  );
};
